export default __webpack_public_path__ + "static/media/rupee.13ecbd43.svg";